export default "__VITE_ASSET__CtBkuczl__"